var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 0.666687V2.00002H9.99999V0.666687H11.3333V2.00002H14C14.3682 2.00002 14.6667 2.2985 14.6667 2.66669V13.3334C14.6667 13.7016 14.3682 14 14 14H1.99999C1.63181 14 1.33333 13.7016 1.33333 13.3334V2.66669C1.33333 2.2985 1.63181 2.00002 1.99999 2.00002H4.66666V0.666687H5.99999ZM13.3333 7.33335H2.66666V12.6667H13.3333V7.33335ZM5.33333 8.66669V10H3.99999V8.66669H5.33333ZM8.66666 8.66669V10H7.33333V8.66669H8.66666ZM12 8.66669V10H10.6667V8.66669H12ZM4.66666 3.33335H2.66666V6.00002H13.3333V3.33335H11.3333V4.66669H9.99999V3.33335H5.99999V4.66669H4.66666V3.33335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.41ba63ff0113b059c6f91297be5aa6f6.svg";
export { ForwardRef as ReactComponent };